/* eslint-disable */
import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import Select from "react-select";

// import { Editor } from "@tinymce/tinymce-react";
//import JoditEditor from "jodit-react";

import { useTranslation } from "react-i18next";

/*import url and gateway methods */
import {
  getData,
  postData,
  putData,
  uploadMultipleFile,
  uploadSingleFile,
} from "utils/Gateway";
import * as url from "helper/UrlHelper";

// clipboardCopy for mail variables
import clipboardCopy from "clipboard-copy";

// import mail variables from json file
import mailVariables from "data/Prod/MailVariables.json";
import colorCodes from "data/Prod/Colours.json";

//import other components
import downloadFileHandler from "helper/DownloadFile";
import { joditEditorConfig, reactSelectStyle } from "Config/Config";
import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import SuccessTemplateModal from "../Modal/SuccessTemplateModal";

//image resize for editor
import { resizeOrCompressImage } from "helper/Common/CommonHelper";
import AlertNotification from "../AlertNotification/AlertNotification";
import FileUploadField from "../FileUploadField/FileUploadField";
import JoditEditorField from "../JoditEditorField/JoditEditorField";

const MailTemplateForm = ({ moduleName, breadcrumbText, afterModalClose }) => {
  const token = localStorage.getItem("token"); // token
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const ecosystemSlug = localStorage.getItem("ecosystemslug");

  const params = useParams();
  const formRef = useRef(null);

  //** Language translation */
  const { t } = useTranslation();

  //option for all survey for seclect
  const [allSurveyList, setAllSurveyList] = useState([]);
  const [colorOptions, setColorOptions] = useState([]);

  /*======== form requirement start ==========*/
  const [mailTemplateName, setMailTemplateName] = useState("");
  const [mailTemplateSlug, setMailTemplateSlug] = useState("");
  const [mailTemplateSubject, setMailTemplateSubject] = useState("");
  const [mailTemplateIsPublic, setMailTemplateIsPublic] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [fileUploadIds, setFileUploadIds] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [mailDescription, setMailDescription] = useState(""); //for ck editor

  const [allAddedLinks, setAllAddedLinks] = useState("");
  const [showLinksModal, setShowLinksModal] = useState(false);

  /*======== form requirement end ==========*/

  //* alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const editor = useRef(null);

  // const editorCustomConfig = joditEditorConfig();
  const editorCustomConfig = {
    readonly: false,
    placeholder: "",
    minHeight: 400,
    uploader: {
      insertImageAsBase64URI: false,
    },
    events: {
      afterPaste: async (event) => {
        // take the saved clipboard data
        const clipboardData = event.clipboardData || window.clipboardData;
        const items = clipboardData.items;

        for (let i = 0; i < items.length; i++) {
          if (items[i].type.indexOf("image") !== -1) {
            const file = items[i].getAsFile();

            // Rename the file using a timestamp
            const timestamp = Date.now();
            const fileExtension = file.type.split("/")[1]; // Get the file extension (e.g., png, jpeg)
            const newFileName = `image-${timestamp}.${fileExtension}`;

            const renamedFile = new File([file], newFileName, {
              type: file.type,
            });

            try {
              // upload the file data in server
              const requestUrl =
                url.API_BASE_URL +
                url.API_SINGLE_FILE_UPLOAD +
                `?token=${token}`;

              const response = await uploadSingleFile(requestUrl, renamedFile);

              if (response.status) {
                const imageUrl = url.SERVER_URL + response.data.path;
                // console.log("imageUrl", imageUrl);

                // Replace blob URL with the server URL
                const editorInstance = editor.current;

                if (editorInstance) {
                  const content = editorInstance.value;
                  const regex = /<img[^>]+src="data:image\/[^">]+"/g;
                  const newContent = content.replace(regex, (match) => {
                    const base64DataMatch = match.match(/src="([^"]+)"/);
                    if (
                      base64DataMatch &&
                      base64DataMatch[1].startsWith("data:image/")
                    ) {
                      return match.replace(base64DataMatch[1], imageUrl);
                    }
                    return match;
                  });

                  // add in editor content
                  editorInstance.value = newContent;

                  // add in state content
                  setMailDescription(newContent);
                }
              }
            } catch (error) {
              console.error("Image upload failed:", error);
            }
          }
        }
      },
    },
    defaultActionOnPaste: "insert_as_html",
    defaultLineHeight: 1.5,
    enter: "div",
    statusbar: false,
    sizeLG: 900,
    sizeMD: 700,
    sizeSM: 400,
    toolbarAdaptive: false,
    disablePlugins: [
      "image",
      "video",
      "about",
      "classSpan",
      "file",
      "speechRecognize",
      "copyformat",
      "spellcheck",
      "add-new-line",
    ],
  };

  const editorConfig = useMemo(() => editorCustomConfig, []);

  const colorOptionStyle = {
    display: "flex",
    alignItems: "center",
  };

  const colorBoxStyle = {
    width: "20px",
    height: "20px",
    marginRight: "10px",
    border: "1px solid #000",
  };

  /*=========== form repeater section start ===========*/

  //template for action link block
  const actionLinkTemplate = {
    name: "",
    color: null,
    colordata: null,
    externallink: "",
    surveyvalue: null,
    surveydata: null,
  };

  //** Requirement for action link block */
  const [actionLinkBlock, setActionLinkBlock] = useState([]);

  //link tracker block
  const linkTrackerTemplate = {
    link: "",
    label: "",
  };

  const handleCheckboxChange = (e, linkData) => {
    if (e.target.checked) {
      setlinkTrackerBlock([...linkTrackerBlock, linkData]);
    } else {
      setlinkTrackerBlock(
        linkTrackerBlock.filter((item) => item.link !== linkData.link)
      );
    }
  };

  const [linkTrackerBlock, setlinkTrackerBlock] = useState([]);

  //** Hooks for validation */
  const [errors, setErrors] = useState({});

  const [isSaving, setIsSaving] = useState(false);

  //** Function to navigate to survey question */
  const getAllSurvey = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_SURVEY + `?token=${token}`;

      const response = await getData(requestUrl);
      // console.log(response);

      if (response.status) {
        setAllSurveyList(
          response.data.map((survey) => ({
            label: survey.name,
            value: survey._id,
          }))
        );
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    }
  };

  //** Function for addign action link section */
  const addActionLinkBlock = () => {
    setActionLinkBlock([...actionLinkBlock, actionLinkTemplate]);
  };

  //** Function for delete action link block */
  const onDeleteActionLinkBlock = (index) => {
    const filteredActionLinkBlock = [...actionLinkBlock];
    filteredActionLinkBlock.splice(index, 1);
    setActionLinkBlock(filteredActionLinkBlock);
  };

  //** Function for change survey select */
  const changeActionLinkColorSelect = (index, field, field2, value) => {
    const updatedFormValues = actionLinkBlock.map((block, i) =>
      index == i
        ? Object.assign(block, { [field]: value, [field2]: value.value })
        : block
    );
    setActionLinkBlock(updatedFormValues);
  };

  //** Function for change survey select */
  const changeActionLinkSurveySelect = (index, field, field2, value) => {
    const updatedFormValues = actionLinkBlock.map((block, i) =>
      index == i
        ? Object.assign(block, { [field]: value, [field2]: value.value })
        : block
    );
    setActionLinkBlock(updatedFormValues);
  };

  //** Function for other action link input field */
  const changeActionLinkInputs = (index, field, value) => {
    const updatedFormValues = actionLinkBlock.map((block, i) =>
      index == i ? Object.assign(block, { [field]: value }) : block
    );
    // console.log(`updatedFormValues`, updatedFormValues);
    setActionLinkBlock(updatedFormValues);
  };

  //** Function for mapping form repeater data */
  const updatedActionLinkBlock = (actionLink) => {
    const actionLinkArr = actionLink.map((actionLinkData) => {
      return {
        _id: actionLinkData?._id,
        name: actionLinkData?.name,
        color: actionLinkData?.color,
        colordata: getColorcodeLabel(actionLinkData.color),
        externallink: actionLinkData?.externallink,
        surveyvalue: actionLinkData?.survey,
        surveydata: actionLinkData?.survey?.value,
      };
    });
    // console.log("actionLinkArr >>>>>> ", actionLinkArr);
    setActionLinkBlock(actionLinkArr);
  };

  const getColorcodeLabel = (colorCode) => {
    return {
      label: (
        <div style={colorOptionStyle}>
          <div style={{ ...colorBoxStyle, backgroundColor: colorCode }} />
        </div>
      ),
      value: colorCode,
    };
  };
  /*=========== form repeater section end ===========*/

  //for adding a new link tracker block
  const onAddLinkTrackerBlock = () => {
    setShowLinksModal(true);

    // show modal with id selectLinksModal
    const modal = new bootstrap.Modal(
      document.getElementById("selectLinksModal")
    );
    modal.show();

    //setlinkTrackerBlock([...linkTrackerBlock, linkTrackerTemplate]);
  };

  //** Function for delete link tracker block */
  const onDeleteLinkTrackerBlock = (index) => {
    const filteredLinkTrackerBlock = [...linkTrackerBlock];
    filteredLinkTrackerBlock.splice(index, 1);
    setlinkTrackerBlock(filteredLinkTrackerBlock);
  };

  //** Function for change link tracker value */
  const changeLinkTrackerValue = (index, field, value) => {
    const updatedFormValues = linkTrackerBlock.map((block, i) =>
      index == i ? Object.assign(block, { [field]: value }) : block
    );
    setlinkTrackerBlock(updatedFormValues);
  };

  //** Function for mapping form repeater data */
  const updatedLinkTrackerBlock = (linkTracker) => {
    const linkTrackerArr = linkTracker.map((linkTrackerData) => {
      return {
        _id: linkTrackerData?._id,
        link: linkTrackerData?.link,
        label: linkTrackerData?.label,
      };
    });
    // console.log("linkTrackerArr >>>>>> ", linkTrackerArr);
    setlinkTrackerBlock(linkTrackerArr);
  };

  //** Function for file upload */
  const uploadHandler = async (files) => {
    try {
      setIsUploading(true);

      let requestUrl =
        url.API_BASE_URL + url.API_MULTIPLE_FILE_UPLOAD + `?token=${token}`;

      const response = await uploadMultipleFile(requestUrl, files);

      if (response.status) {
        /*----- assign uploaded files with path for display start ------*/
        const uploadedFileValues = response.data.map(
          ({ name, path, _id, ...other }) => ({
            name,
            path: url.SERVER_URL + path,
            _id,
          })
        );
        //check old file exist or not if exist then new file will concat with old file
        if (uploadedFiles.length == 0) {
          setUploadedFiles(uploadedFileValues);
        } else {
          let fileArr = uploadedFiles.concat(uploadedFileValues);
          setUploadedFiles(fileArr);
        }
        /*----- assign uploaded files with path for display end ------*/
        setIsUploading(false);
        /*----- assign uploaded file ids start ------*/
        const fileIds = response.data.map(({ _id, ...other }) => ({ _id }));
        //check old file ids are exist or not.If exist then new id will concat with old id
        if (fileUploadIds.length == 0) {
          setFileUploadIds(fileIds);
        } else {
          let fileArr = fileUploadIds.concat(fileIds);
          setFileUploadIds(fileArr);
        }
        /*----- assign uploaded file ids end ------*/
      } else {
        setAlertMessage(response.message);
        setMessageType("error");
        setShowAlert(true);
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    }
  };

  //** Function for delete file from upload stack */
  const closeFileHandler = (index) => {
    const closedFile = [...uploadedFiles];
    const removedFileId = [...fileUploadIds];
    closedFile.splice(index, 1);
    removedFileId.splice(index, 1);
    setUploadedFiles(closedFile);
    setFileUploadIds(removedFileId);
  };

  //** Function for get template details */
  const getTemplateDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_TEMPLATE_DETAILS +
        `/${params.id}?token=${token}`;

      const response = await getData(requestUrl);

      console.log(response);

      if (response.status && response.data) {
        setMailTemplateName(response.data.name);
        setMailTemplateSlug(response.data.slug);
        setMailTemplateSubject(response.data.subject);
        setMailTemplateIsPublic(response.data.ispublic);
        setMailDescription(response.data.description);
        if (response.data.actionlinks.length > 0) {
          updatedActionLinkBlock(response.data?.actionlinks);
        }
        /*----- assign uploaded files with path for display start ------*/
        if (
          response.data.linktrackerids &&
          response.data.linktrackerids.length > 0
        ) {
          updatedLinkTrackerBlock(response.data.linktrackerids);
        }

        const uploadedFileValues = response.data?.uploads.map(
          ({ name, path, _id, ...other }) => ({
            name,
            path: url.SERVER_URL + path,
            _id,
          })
        );
        //check old file exist or not if exist then new file will concat with old file
        if (uploadedFiles.length == 0) {
          setUploadedFiles(uploadedFileValues);
        } else {
          let fileArr = uploadedFiles.concat(uploadedFileValues);
          setUploadedFiles(fileArr);
        }
        /*----- assign uploaded files with path for display end ------*/
        /*----- assign uploaded file ids start ------*/
        const fileIds = response.data?.uploads?.map(({ _id, ...other }) => ({
          _id,
        }));
        //check old file ids are exist or not.If exist then new id will concat with old id
        if (fileUploadIds.length == 0) {
          setFileUploadIds(fileIds);
        } else {
          let fileArr = fileUploadIds.concat(fileIds);
          setFileUploadIds(fileArr);
        }
        /*----- assign uploaded file ids end ------*/
      } else {
        setAlertMessage(response.message);
        setMessageType("error");
        setShowAlert(true);
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    }
  };

  //** Validate function */
  const validateForm = () => {
    const newErrors = {};
    if (!mailTemplateName.trim()) {
      newErrors.name = t(
        "Template name is required. Please enter a name for this template."
      );
    }
    if (!mailTemplateSlug.trim()) {
      newErrors.slug = t(
        "Slug is required. Please enter a unique, URL-friendly identifier."
      );
    }
    if (!mailTemplateSubject.trim()) {
      newErrors.subject = t(
        "Subject is required. Please enter a subject line for the email."
      );
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //** Function for save mail template */
  const saveMailTemplateHandler = async () => {
    if (!validateForm()) {
      if (formRef.current) {
        formRef.current.scrollIntoView({ behavior: "smooth" });
      }
      return;
    }

    setIsSaving(true);
    try {
      let templateData = {
        status: "1",
        name: mailTemplateName,
        slug: mailTemplateSlug,
        subject: mailTemplateSubject,
        ispublic:
          moduleName === "CRM" ? "false" : mailTemplateIsPublic.toString(),
        description: mailDescription,
        actionlinks: actionLinkBlock,
        linktrackers: linkTrackerBlock,
        uploads: fileUploadIds,
        moduleslug: moduleName,
      };

      let requestUrl = url.API_BASE_URL;

      let response = {};

      if (params.id) {
        requestUrl =
          requestUrl +
          url.API_UPDATE_MAIL_TEMPLATE +
          `/${params.id}?token=${token}`;

        response = await putData(requestUrl, templateData);
      } else {
        requestUrl =
          requestUrl + url.API_CREATE_MAIL_TEMPLATE + `?token=${token}`;

        response = await postData(requestUrl, templateData);
      }

      setIsSaving(false);

      console.log(response);

      if (response.status) {
        resetHandler();
        setMessageType("success");
        const bootstrapModal = new bootstrap.Modal(
          document.getElementById("afterSaveTemplateModal")
        );

        bootstrapModal.show();
      } else {
        setMessageType("error");
      }

      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    }
    setShowAlert(true);
  };

  //** Function for clear file value */
  const resetFile = () => {
    const file = document.getElementById("uploadedMailTemplateFile");
    if (file) {
      file.value = null;
    } else {
      return;
    }
  };

  /* reset */
  const resetHandler = () => {
    setMailTemplateName("");
    setMailTemplateSlug("");
    setMailTemplateSubject("");
    setMailDescription("");
    setFileUploadIds([]);
    setUploadedFiles([]);
    resetFile();
    setActionLinkBlock([]);
    setlinkTrackerBlock([]);
    setErrors({});
  };

  const getOptionsFromColorCodeJson = () => {
    return colorCodes.map((color) => ({
      label: (
        <div style={colorOptionStyle}>
          <div style={{ ...colorBoxStyle, backgroundColor: color.code }} />
        </div>
      ),
      value: color.code,
    }));
  };

  useEffect(() => {
    if (params.id) {
      getTemplateDetails();
    }
  }, [params.id]);

  useEffect(() => {
    getAllSurvey();
    const options = getOptionsFromColorCodeJson();
    setColorOptions(options);
  }, []);

  // get links from mail description
  useEffect(() => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(mailDescription, "text/html");
    const anchors = doc.querySelectorAll("a");

    const linksArray = Array.from(anchors).map((a) => ({
      link: a.getAttribute("href"), // Preserves the original href format
      label: a.innerText || a.getAttribute("href"),
    }));

    setAllAddedLinks(linksArray);
  }, [mailDescription]);

  //* This is a function that is called when the alert close button is clicked.
  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  return (
    <div className="container-fluid px-lg-5">
      <BreadCrumb breadCrumbText={breadcrumbText} />
      <div
        ref={formRef}
        className="create-lead-container p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm mt-2"
      >
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="fields-container flex-fill">
            {/* ------- template name start ------ */}
            <div className="form-group mb-4">
              <label
                htmlFor="mailTemplateName"
                className="d-block fs-sm fw-semibold mb-2"
              >
                {t("Template Name")} *
              </label>
              <input
                type="text"
                id="mailTemplateName"
                placeholder={t(
                  "Enter a descriptive name for your template, e.g., Monthly Newsletter"
                )}
                className={`form-control shadow-none ${
                  errors.name ? "is-invalid" : "border border-gray-300"
                }`}
                value={mailTemplateName}
                onChange={(e) => {
                  setMailTemplateName(e.target.value);
                  if (errors.name) {
                    setErrors((prev) => ({ ...prev, name: "" }));
                  }
                }}
              />
              {errors.name && (
                <div className="invalid-feedback">{errors.name}</div>
              )}
            </div>
            {/* ------- template name end ------ */}

            {/* ------- template slug start ------ */}
            <div className="form-group mb-4">
              <label
                htmlFor="mailTemplateSlug"
                className="d-block fs-sm fw-semibold mb-2"
              >
                {t("Slug")} *
              </label>
              <input
                type="text"
                id="mailTemplateSlug"
                placeholder={t(
                  "Enter a unique identifier, e.g., monthly-newsletter"
                )}
                className={`form-control shadow-none ${
                  errors.slug ? "is-invalid" : "border border-gray-300"
                }`}
                value={mailTemplateSlug}
                onChange={(e) => {
                  setMailTemplateSlug(e.target.value);
                  if (errors.slug) {
                    setErrors((prev) => ({ ...prev, slug: "" }));
                  }
                }}
              />
              {errors.slug && (
                <div className="invalid-feedback">{errors.slug}</div>
              )}
            </div>
            {/* ------- template slug end ------ */}

            {/* ------- template subject start ------ */}
            <div className="form-group mb-4">
              <label
                htmlFor="mailTemplateSubject"
                className="d-block fs-sm fw-semibold mb-2"
              >
                {t("Subject")} *
              </label>
              <input
                type="text"
                id="mailTemplateSubject"
                placeholder={t(
                  "Enter an engaging subject line, e.g., Your Weekly Updates!"
                )}
                className={`form-control shadow-none ${
                  errors.subject ? "is-invalid" : "border border-gray-300"
                }`}
                value={mailTemplateSubject}
                onChange={(e) => {
                  setMailTemplateSubject(e.target.value);
                  if (errors.subject) {
                    setErrors((prev) => ({ ...prev, subject: "" }));
                  }
                }}
              />
              {errors.subject && (
                <div className="invalid-feedback">{errors.subject}</div>
              )}
            </div>
            {/* ------- template subject end ------ */}
            {/* ------- template mail variable select start ------ */}
            <div className="form-group mb-4">
              <div className="row">
                <label htmlFor="" className="d-block fs-sm fw-semibold mb-2">
                  {t("Mail Variable")}
                </label>
                <div className="col-lg-6 mb-4 mb-lg-0">
                  <Select
                    className="w-100"
                    styles={reactSelectStyle("3px", "6px", true, false)}
                    placeholder={t("Click to select a variable to copy")}
                    options={mailVariables}
                    onChange={(event) => {
                      clipboardCopy(event.value);
                    }}
                  />
                </div>
                <div className="col-lg-6">
                  <div className="mail_vairable_text border border-gray-300 field-container d-flex flex-column flex-lg-row gap-3 gap-lg-0 align-items-lg-center body-lg-bg rounded-10">
                    {t(
                      "Select the mail variable you want to add. Next just paste where you want it use it."
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* ------- template mail variable select end ------ */}
            {/* ----- is public section start ----- */}
            <div
              className={moduleName === "CRM" ? "d-none" : "form-group mb-4"}
            >
              <label className="d-block fs-sm fw-semibold mb-2">
                {t("Is public")}
              </label>
              <div className="form-check">
                <input
                  className="form-check-input "
                  type="checkbox"
                  name="ispublic"
                  id="ispublic"
                  checked={mailTemplateIsPublic}
                  onChange={(e) => setMailTemplateIsPublic(e.target.checked)}
                />
              </div>
            </div>
            {/* ----- is public section end ----- */}

            {/* ------- editor section start ------- */}
            <JoditEditorField
              label={t("Details")}
              value={mailDescription}
              onChange={(newContent) => setMailDescription(newContent)}
              labelClassName="d-block fs-sm fw-semibold mb-2"
            />

            {/* ------- editor section end ------- */}

            {/* ========= file upload start ========== */}
            <div className="form-group mb-4">
              <label
                htmlFor="Attachments"
                className="d-block fs-sm fw-semibold mb-2"
              >
                {t("Attachments")}
              </label>

              <FileUploadField
                label={t("Attachments")}
                accept="doc mp4 pdf"
                onUpload={uploadHandler}
                files={uploadedFiles}
                onRemove={closeFileHandler}
                loading={isUploading}
                multiple
                fileType="document"
              />
            </div>
            {/* ========= file upload end ===========*/}

            {/* <!-- ========== Start link tracker Section ========== --> */}
            <div className="form-group">
              <div className="row">
                <div className="col-lg-6 mb-4 mb-lg-0">
                  <label htmlFor="" className="d-block fs-sm fw-semibold mb-2 ">
                    {t("Link Tracker")}{" "}
                    <span className="text-primary ms-1">
                      * {t("1. use exact link")}
                    </span>
                    <span className="text-primary ms-2">
                      * {t("2. use http or https")}
                    </span>
                    <span className="text-primary ms-2">
                      * {t("3. each link should be unique")}
                    </span>
                  </label>
                </div>
              </div>
            </div>

            {/* <!-- ========== Start list of link tracker Section ========== --> */}
            {linkTrackerBlock.map((trackerBlock, index) => {
              return (
                <div
                  className="form-group p-3 bg-gray-500 mb-3 action_link_block_bg"
                  key={index}
                >
                  <div className="row">
                    {/* ------ action link name start ------ */}
                    <div className="col-lg-6 mb-1">
                      <label>{t("Add url to track")}</label>
                      <input
                        type="text"
                        name="link"
                        className="form-control bg-white"
                        placeholder={t("https://example.com/your-link")}
                        value={trackerBlock.link}
                        onChange={(e) => {
                          changeLinkTrackerValue(index, "link", e.target.value);
                        }}
                      />
                    </div>
                    {/* ------ action link name end ------ */}

                    {/* ------ action link external start ------ */}
                    <div className="col-lg-5 mb-1">
                      <label>{t("Label to display if link clicked")}</label>
                      <input
                        type="text"
                        name="label"
                        className="form-control bg-white"
                        placeholder={t("e.g., Visited our new feature page")}
                        value={trackerBlock.label}
                        onChange={(e) => {
                          changeLinkTrackerValue(
                            index,
                            "label",
                            e.target.value
                          );
                        }}
                      />
                    </div>
                    {/* ------ action link external end ------ */}

                    <div className="col-lg-1 mb-1 pt-5">
                      <Link
                        to="#"
                        className="text-danger mt-2"
                        onClick={() => {
                          onDeleteLinkTrackerBlock(index);
                        }}
                      >
                        <span className="material-symbols-outlined">close</span>
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}

            {/* <!-- ========== End list of link tracker Section ========== --> */}

            {/* <!-- ========== Start add new link tracker button ========== --> */}
            <div className="form-group mb-5">
              <div className="row">
                <div className="col-3">
                  <Link
                    onClick={onAddLinkTrackerBlock}
                    to="#"
                    className="text-primary fw-medium d-inline-flex align-items-center gap-1 text-decoration-none"
                  >
                    <span className="d-block material-symbols-outlined">
                      add_circle
                    </span>
                    <span>{t("Add Link Tracker")}</span>
                  </Link>
                </div>
              </div>
            </div>
            {/* <!-- ========== End add new link tracker button ========== --> */}

            {/* <!-- ========== End link tracker Section ========== --> */}
          </div>
          <div className="action d-flex align-items-center justify-content-between gap-3 py-4 border-top mt-auto">
            <Link
              to={
                moduleName === "CRM"
                  ? "/admin/crm/mailtemplate/list"
                  : "/admin/administration/mailtemplate/list"
              }
              className="btn btn-outline-primary"
            >
              {t("Cancel")}
            </Link>

            <button
              onClick={saveMailTemplateHandler}
              type="button"
              className="btn btn-primary"
              style={{ cursor: isSaving ? "not-allowed" : "pointer" }}
              disabled={isSaving ? true : false}
            >
              {t("Save Template")}
              {isSaving && (
                <div
                  className="mx-2 spinner-border spinner-border-sm"
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
            </button>
          </div>
        </form>
      </div>

      <SuccessTemplateModal
        afterSaveTeamplateModalClose={afterModalClose}
        moduleName={moduleName}
      />

      {showAlert && (
        <AlertNotification
          showAlert={showAlert}
          message={alertMessage}
          alertType={messageType}
          onClose={onAlertClose}
        />
      )}

      {/* select links in content */}
      <div
        className="modal modal-lg fade"
        id="selectLinksModal"
        tabIndex="-1"
        aria-labelledby="selectLinksModal"
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content bg-white border-0 rounded-15">
            {/* Modal Header */}
            <div className="modal-header p-4 pb-0 border-0">
              <h2 className="fw-bold mb-0">Select Links</h2>
              <button
                type="button"
                className="btn-close p-0 bg-gray-200 rounded-circle shadow-none"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            {/* Modal Body */}
            <div className="modal-body p-4">
              <div className="table-responsive">
                <table className="table table-bordered align-middle">
                  <thead className="table-light">
                    <tr>
                      <th style={{ width: "10%" }} className="text-center">
                        Select
                      </th>
                      <th style={{ width: "40%" }}>Label</th>
                      <th style={{ width: "50%" }}>Link</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allAddedLinks && allAddedLinks.length > 0 ? (
                      allAddedLinks.map((item, index) => (
                        <tr key={index}>
                          <td className="text-center">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              onChange={(e) => handleCheckboxChange(e, item)}
                              style={{ border: "1px solid #000" }}
                            />
                          </td>
                          <td>{item.label}</td>
                          <td>
                            <a
                              href={item.link}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {item.link}
                            </a>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center text-muted">
                          No links found in the email content. Please add links
                          first.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* Close Button */}
              <div className="text-end mt-3">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* select links ends  */}
    </div>
  );
};

export default MailTemplateForm;
